import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { AiFillEdit, AiOutlineFileGif } from 'react-icons/ai';
import { BsAspectRatio } from 'react-icons/bs';
import { FaInstagram, FaRegClosedCaptioning } from 'react-icons/fa';
import { FiSmartphone } from 'react-icons/fi';
import { GiDigitalTrace } from 'react-icons/gi';
import { HiOutlineMail } from 'react-icons/hi';
import { ImFilm, ImQrcode } from 'react-icons/im';
import { IoMdGift } from 'react-icons/io';
import { MdDesktopWindows } from 'react-icons/md';
import { VscFileMedia } from 'react-icons/vsc';
import { useHistory, useParams } from 'react-router';
import NewFormWizard from '../../components/formWizard/NewFormWizard';
import Layout from '../../components/layouts/Layout';
import http from '../../config/BaseUrl';
import LocalStorage from '../../hook/LocalStorage';
import { getPackagePermissions } from '../events/packageAccess';

const EventOptionEdit = () => {
    const { id } = useParams();
    const history = useHistory();
    const { user } = LocalStorage()
    const membershipPackageId = user?.membership?.package_id ?? user?.membership?.our_package?.id
    const eventOptionItem = history.location.state.eventOption
    const feature = history.location.state.eventFeature
    const [packageTypes, setPackageTypes] = useState(null)
    const [packageAccessStatus, setPackageAccessStatus] = useState("loading")
    const [packageRequestKey, setPackageRequestKey] = useState(0)
    const [adminPassword, setAdminPassword] = useState(new Array(4).fill(""));
    const [loading, setLoading] = useState(false);


    const { register, handleSubmit } = useForm({
        defaultValues: {
            gif: eventOptionItem.gif,
            brust_gif: eventOptionItem.brust_gif,
            filters: eventOptionItem.filters,
            digital_props: eventOptionItem.digital_props,
            data_capture: eventOptionItem.data_capture,
            social_media: eventOptionItem.social_media,
            email: eventOptionItem.email,
            text_messaging: eventOptionItem.text_messaging,
            water_mark: eventOptionItem.water_mark,
            microsite: eventOptionItem.microsite,
            incentive_offer: eventOptionItem.incentive_offer,
            qr_code: parseInt(eventOptionItem.qr_code),
            frame: eventOptionItem.frame ? eventOptionItem.frame : 0,
            video_frame: eventOptionItem.video_frame ? eventOptionItem.video_frame : 0,
            boomerang_frame: eventOptionItem.boomerang_frame ? eventOptionItem.boomerang_frame : 0,
            form_builder: eventOptionItem.form_builder ? eventOptionItem.form_builder : 0
        },
        mode: "all",
        reValidateMode: "onChange"
    })

    useEffect(() => {
        if (eventOptionItem) {
            let CreateArr = Object.assign([], eventOptionItem.admin_password);

            setAdminPassword(CreateArr)
        }
    }, [eventOptionItem])

    useEffect(() => {
        let mounted = true

        const loadPackagePermissions = async () => {
            setPackageAccessStatus("loading")
            setPackageTypes(null)

            try {
                const res = await http.get('/package-type')
                const permissions = getPackagePermissions(
                    res?.data?.packageType,
                    membershipPackageId
                )

                if (mounted) {
                    setPackageTypes(permissions)
                    setPackageAccessStatus(
                        Object.values(permissions).some(permission => permission === null)
                            ? "partial"
                            : "ready"
                    )
                }
            } catch (error) {
                if (mounted) {
                    setPackageTypes(null)
                    setPackageAccessStatus("error")
                }
            }
        }

        loadPackagePermissions()

        return () => {
            mounted = false
        }
    }, [membershipPackageId, packageRequestKey])

    const hasPackageAccess = (permission) => (
        (packageAccessStatus === "ready" || packageAccessStatus === "partial") &&
        packageTypes?.[permission] === true
    )

    const getPackageAccessMessage = (permission) => {
        if (packageAccessStatus === "loading") return "Checking package access..."
        if (packageAccessStatus === "error") return "Unable to verify package access"
        if (packageTypes?.[permission] === null || packageTypes?.[permission] === undefined) return "Package access unavailable"
        return packageTypes[permission] ? "" : "Upgrade your package"
    }

    const renderPackageAccessMessage = (permission) => {
        const message = getPackageAccessMessage(permission)

        return message ? <div className="option_inner_popup"><p>{message}</p></div> : null
    }



    const handleChange = (element, index) => {
        if (isNaN(element.value)) return false;
        setAdminPassword([...adminPassword.map((d, idx) => (idx === index ? element.value : d))]);
    };

    const handleKeyPress = (e, index) => {
        if(e.keyCode === 8){
            if(e.target.previousSibling){
                e.target.previousSibling.focus();
            }
        }
        else{
            if (e.target.nextSibling) {
                e.target.nextSibling.focus();
            }
        }
    }

    const handelEventOptionUpdate = async (data) => {
        setLoading(true)
        try {
            const res = await http.post(`event/option/update/${id}`, { ...data, admin_password: adminPassword.join("") })
            setLoading(false)
            if (res) {
                history.push(`/show/event/${eventOptionItem.event_id}`, 'Information Updated.')
            }
        } catch (error) {
            console.error(error)
            setLoading(false)
        }
    }

    return (
        <Layout>
            <NewFormWizard />
            <form onSubmit={handleSubmit(handelEventOptionUpdate)}>
                <section className="mt-5">

                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="px-2 card">
                                <div className="py-5 text-center border-bottom">
                                    <h4 className="text-primary display-4 event-form-title">Event Option</h4>
                                    <span className="text-secondary">Choose the event option</span>
                                </div>
                                <div className="card-body">
                                    {packageAccessStatus === "error" || packageAccessStatus === "partial" ? (
                                        <div className="alert alert-warning d-flex justify-content-between align-items-center" role="alert">
                                            <span>
                                                {packageAccessStatus === "error"
                                                    ? "We could not verify your package access. Package-restricted options are temporarily unavailable."
                                                    : "Some package permissions could not be matched. Those options are temporarily unavailable."}
                                            </span>
                                            <button type="button" className="ml-3 btn btn-sm btn-outline-dark" onClick={() => setPackageRequestKey(key => key + 1)}>
                                                Retry
                                            </button>
                                        </div>
                                    ) : null}
                                    <div className="pt-5 select__photo--area">
                                        <div className="flex-wrap d-flex justify-content-center">

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox" value="" {...register("social_media")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <FaInstagram size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 text-white">Social</p>
                                                    </div>
                                                </label>
                                            </div>


                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox" value="" {...register("gif")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <AiOutlineFileGif size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">3 in 1 Animation</p>
                                                    </div>
                                                </label>
                                            </div>
                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox" value="" {...register("brust_gif")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <ImFilm size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Speed Burst</p>
                                                    </div>
                                                </label>
                                            </div>


                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox"
                                                        disabled={!hasPackageAccess("email")}
                                                        value="" {...register("email")} />
                                                    <div className={`option_inner photo__booth ${hasPackageAccess("email") ? '' : 'disable-item'}`}>
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <HiOutlineMail size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 text-white">Email</p>
                                                    </div>
                                                    {renderPackageAccessMessage("email")}
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox"
                                                        disabled={!hasPackageAccess("text_messaging")}
                                                        value="" {...register("text_messaging")} />
                                                    <div className={`option_inner photo__booth ${hasPackageAccess("text_messaging") ? '' : 'disable-item'}`}>
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <FiSmartphone size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 text-white">SMS Sharing</p>
                                                    </div>
                                                    {renderPackageAccessMessage("text_messaging")}
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox" value="" {...register("digital_props")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <GiDigitalTrace size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 text-white">Props</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" disabled={!hasPackageAccess("custom_branding")} className="checkbox" value="" {...register("water_mark")} />
                                                    <div className={`option_inner photo__booth ${hasPackageAccess("custom_branding") ? '' : 'disable-item'}`}>
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <FaRegClosedCaptioning size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Custom Branding</p>
                                                    </div>
                                                    {renderPackageAccessMessage("custom_branding")}
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox"
                                                        disabled={!hasPackageAccess("microsite")}
                                                        value="" {...register("microsite")} />
                                                    <div className={`option_inner photo__booth ${hasPackageAccess("microsite") ? '' : 'disable-item'}`}>
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <MdDesktopWindows size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 text-white">Social Gallery</p>
                                                    </div>
                                                    {renderPackageAccessMessage("microsite")}
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox" {...register("frame")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <BsAspectRatio size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 text-white">Selfie Frame</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox" {...register("video_frame")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <BsAspectRatio size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 text-white">Video Frame</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox" {...register("boomerang_frame")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <BsAspectRatio size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 text-white">Boomerang Frame</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox" value="" {...register("qr_code")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <ImQrcode size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 text-white">QR Code</p>
                                                    </div>
                                                </label>
                                            </div>
                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input
                                                        type="checkbox"
                                                        className="checkbox"
                                                        disabled={!hasPackageAccess("incentive_offer")}
                                                        value="" {...register("incentive_offer")} />
                                                    <div className={`option_inner photo__booth ${hasPackageAccess("incentive_offer") ? '' : 'disable-item'}`}>
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <IoMdGift size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white"> Incentives & Offers</p>
                                                    </div>
                                                    {renderPackageAccessMessage("incentive_offer")}
                                                </label>
                                            </div>
                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox" value="" {...register("filters")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <VscFileMedia size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 text-white">Filters</p>
                                                    </div>
                                                </label>
                                            </div>

                                            {
                                                feature.data_capture ?
                                                    <div className="photo__booth__area_checkbox">
                                                        <label className="option_item">
                                                            <input
                                                                type="checkbox"
                                                                className="checkbox"
                                                                disabled={!hasPackageAccess("form_builder")}
                                                                value="" {...register("form_builder")} />
                                                            <div className={`option_inner photo__booth ${hasPackageAccess("form_builder") ? '' : 'disable-item'}`}>
                                                                <div className="tick-mark"></div>
                                                                <div className="icon">
                                                                    <AiFillEdit size={25} color={'#fff'} />
                                                                </div>
                                                                <p className="mt-2 mb-0 text-white">Form Builder</p>
                                                            </div>
                                                            {renderPackageAccessMessage("form_builder")}
                                                        </label>
                                                    </div>
                                                    : ""
                                            }

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="my-5 col d-flex justify-content-between align-items-center">
                                            <div className="admin">
                                                <h2>Admin Password</h2>
                                                <p className="text-secondary">Keep your event safe by securing it with a numerical password.</p>

                                            </div>
                                            <div className="pin">
                                                <p className="mb-0 text-primary">Password</p>
                                                <div className="d-flex">
                                                    {adminPassword && adminPassword.map((data, index) => (
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="otp"
                                                            maxLength="1"
                                                            key={index}
                                                            value={data}
                                                            onKeyUp={e => handleKeyPress(e, index)}
                                                            onChange={e => handleChange(e.target, index)}
                                                            onFocus={e => e.target.select()}
                                                            required
                                                        />
                                                    )
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>








                    </div>
                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            <button type="submit" disabled={loading} className="float-right px-5 btn btn-primary radius-30">
                                {loading ?
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Updating...
                                    </>
                                    : "Update"
                                }
                            </button>
                        </div>
                    </div>
                </section>
            </form>
        </Layout>
    )
}

export default EventOptionEdit
